import Store from './interfaces/Store';
import config from '../config';
import Compressor from 'compressorjs';

let headers = new Headers();
const LAST_UPDATE = 'lastUpdate';

export default class RestStore extends Store {
  set lastUpdate(lastUpdate) {
    setCookie(LAST_UPDATE, lastUpdate - 60000, 1000);
  }
  get lastUpdate() {
    const lastUpd = getCookie(LAST_UPDATE) || 0;
    console.log(lastUpd);
    return 1;
  }

  getAll(type, lastedit) {
    const fetchConfig = {
      method: 'GET',
      headers: headers,
      mode: 'cors',
      cache: 'default'
    };
    const lasteditParam = (lastedit === 0 || !!lastedit) ? lastedit : this.lastUpdate;
    console.log(lasteditParam);
    let params = { 'lastedit': lasteditParam };
    if (!!type) {
      params.tipologia = type;
    }
    this.lastUpdate = new Date().getTime();
    return _sendRequest(config.restBackendUrl, fetchConfig, params);
  }
  get(type, id) {
    const fetchConfig = {
      method: 'GET',
      headers: headers,
      mode: 'cors',
      cache: 'default'
    };
    const params = { 'lastedit': 0, 'tipologia': type, 'id': id };
    return _sendRequest(config.restBackendUrl, fetchConfig, params);
  }
  add(type, obj) {
    let wrapped = {
      content: obj,
      tipologia: type
    };
    const fetchConfig = {
      method: 'POST',
      headers: headers,
      mode: 'cors',
      cache: 'default',
      body: JSON.stringify(wrapped)
    };
    return _sendRequest(config.restBackendUrl, fetchConfig)
      .then(resp => resp.json());
  }
  remove(type, obj) {
    console.log(obj);

    if (!isNaN(obj)) {
      obj = { id: obj };
    }
    let wrapped = {
      content: obj,
      tipologia: type,
      id: obj.id
    };
    const fetchConfig = {
      method: 'DELETE',
      headers: headers,
      mode: 'cors',
      cache: 'default',
      body: JSON.stringify(wrapped)
    };
    return _sendRequest(config.restBackendUrl, fetchConfig);
  }
  delete(type, id) {
    return this.remove(type, id);
  }
  update(type, id, obj) {
    let wrapped = {
      content: obj,
      tipologia: type
    };
    const fetchConfig = {
      method: 'PUT',
      headers: headers,
      mode: 'cors',
      cache: 'default',
      body: JSON.stringify(wrapped)
    };
    return _sendRequest(config.restBackendUrl, fetchConfig);
  }

  getUploadUrl(file, contentType, fileName) {
    const url = 'https://apilife.betards.ninja/s3url';
    const fetchConfig = {
      method: 'GET',
      headers: headers,
      mode: 'cors',
      cache: 'default'
    };
    // const contentType = detectMimeType(b64);
    const params = { 'fileName': fileName, 'contentType': contentType };
    console.log('URL:', url);
    return _sendRequest(url, fetchConfig, params);
  }

  getUploadUrlPromiseResolve(file, contentType, fileName) {
    return this.getUploadUrl(file, contentType, fileName).then(p => p.json());
  }

  uploadFile(url, contentType, file) {
    return new Promise((resolve, reject) => {
      const _headers = new Headers();
      compressImage(file)
        .then(file => {
          _headers.append('Content-Type', contentType);
          const fetchConfig = {
            method: 'PUT',
            headers: _headers,
            mode: 'cors',
            cache: 'default',
            body: file
          };
          resolve(_sendRequest(url, fetchConfig));
        });
    });
  }
  sendRequest = _sendRequest;

  get headers() {
    return headers;
  }
}

function compressImage(file) {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: 1,
      maxWidth: config.IMG_MAX_WIDTH,
      maxHeight: config.IMG_MAX_HEIGTH,
      success(result) {
        resolve(result);
      }
    });
  });
}

function initHeaders() {
  headers.append('Content-Type', 'application/json');
  headers.append('Accept', 'application/json');
}
function _sendRequest(url, fetchConfig, params) {
  let paramsStrings = [];
  if (params) {
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        paramsStrings.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
      }
    }
    url += '?' + paramsStrings.join('&');
  }
  const req = new Request(url, fetchConfig);
  return fetch(req);
}

initHeaders();

function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}
function setCookie(name, value, days) {
  var d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
}
